import { API_CONSTANTS, deleteApiCall, getApiCall, postApiCall, putApiCall } from "../../config/api-constants";
import toast from "react-hot-toast";

export const SHOW_CL_MODAL = "SHOW_CL_MODAL";
export const GET_CL_LIST = "GET_CL_LIST";
export const GET_CL_TAG_LIST = "GET_CL_TAG_LIST";
export const GET_CL_SUMMARY_TAG_LIST = "GET_CL_SUMMARY_TAG_LIST";
export const ADD_NEW_NARRATIVE_COMMENT = "ADD_NEW_NARRATIVE_COMMENT";
export const EDIT_NARRATIVE_COMMENT = "EDIT_NARRATIVE_COMMENT";
export const UPDATE_DROPDOWN_VALUES = "UPDATE_DROPDOWN_VALUES";
export const DELETE_NARRATIVE_COMMENT = "DELETE_NARRATIVE_COMMENT";
export const GET_FULL_CL_LIST = "GET_FULL_CL_LIST";
export const SET_EDITOR_LISTNER = "SET_EDITOR_LISTNER";
export const DUPLICATE_COMMENT = "DUPLICATE_COMMENT";
export const SET_IS_HT_COMPANY = "SET_IS_HT_COMPANY";
export const GET_NN_TAG_LIST = "GET_NN_TAG_LIST";
export const SAVE_REORDER_SUMMARY = "SAVE_REORDER_SUMMARY";

export const setShowCommentLibraryModal = (value) => {
  return {
    type: SHOW_CL_MODAL,
    payload: value,
  };
};

// The API has returned this flag both as a boolean and as 1/0, and sessionStorage
// always hands it back as a string. Normalise every source to a real boolean so
// consumers only ever see true/false, and undefined strictly means "not resolved yet".
export const normalizeIsHTCompany = (value) => {
  if (value === undefined || value === null || value === "") return undefined;
  if (typeof value === "string") {
    if (value === "true" || value === "1") return true;
    if (value === "false" || value === "0") return false;
    return undefined;
  }
  if (typeof value === "number") return value === 1;
  return Boolean(value);
};

export const setIsHTCompany = (value) => {
  const isHTCompany = normalizeIsHTCompany(value);
  if (isHTCompany !== undefined) {
    sessionStorage.setItem("is_ht_company", String(isHTCompany));
  }
  return {
    type: SET_IS_HT_COMPANY,
    payload: isHTCompany,
  };
};

export const getCommentLibraryList = (
  page = null,
  pageCount = null,
  formData = null,
  search = null,
  rowsPerPage = null,
  skipStore = false
) => {
  return async (dispatch) => {
    try {
      let queryString = `?rows_per_page=${rowsPerPage || parseInt(sessionStorage.getItem("commentsRowPerPage"), 10) || 10}`;

      // Build base pagination query
      if (page) queryString += `&page=${page}`;
      else if (pageCount) queryString += `&page_count=${pageCount}`;

      // Add search query (handles cases whether ? already exists or not)
      if (search) {
        queryString += queryString ? `&searchText=${search}` : `?searchText=${search}`;
      }

      let response;

      if (page || pageCount || search) {
        response = await postApiCall(
          `${API_CONSTANTS.GET_COMMENT_LIBRARY_LIST}${queryString}`,
          formData
        );
      }

      // Texas templates in a narrative company read the narrative library but keep
      // their own local list, so the shared narrative store must stay untouched.
      if (skipStore) return { payload: response?.data?.data };

      if (page)
        return dispatch({
          type: GET_CL_LIST,
          payload: response?.data?.data,
        });
      else if (pageCount)
        return dispatch({
          type: GET_FULL_CL_LIST,
          payload: response?.data?.data,
        });
    } catch (error) {
      throw error;
    }
  };
};
export const unsetCommentLibraryList = () => {
  return {
    type: GET_CL_LIST,
    payload: { data: undefined },
  };
}

export const getCommentLibraryTagList = () => {
  return async (dispatch) => {
    try {
      const response = await getApiCall(API_CONSTANTS.GET_COMMENT_LIB_TAGS_LIST);
      return dispatch({ type: GET_CL_TAG_LIST, payload: response?.data?.data || [] });
    } catch (error) {
      throw error;
    }
  };
};

export const getCommentLibrarySummaryTagList = () => {
  return async (dispatch) => {
    try {
      const response = await getApiCall(API_CONSTANTS.GET_COMMENT_LIB_SUMMARY_TAG_LIST);
      const sorted = (response?.data?.data || []).slice().sort((a, b) => a.order - b.order);
      return dispatch({ type: GET_CL_SUMMARY_TAG_LIST, payload: sorted });
    } catch (error) {
      throw error;
    }
  };
};

export const addNewNarrativeComment = (newCommentData) => {
  return async (dispatch) => {
    try {
      const newAddData = {
        ...newCommentData,
        tag_ids: newCommentData?.tag_ids?.filter((item) => item !== "")?.map((tag) => parseInt(tag.id)) || [],
        summary_ids: newCommentData?.summary_ids?.filter((item) => item !== "")?.map((summaryTag) => parseInt(summaryTag.id)) || [],
        rating_ids: newCommentData?.rating_ids?.filter((item) => item !== "")?.map((rating) => parseInt(rating.id)) || [],
      };
      const response = await postApiCall(API_CONSTANTS.ADD_COMMENT_NARRATIVE, newAddData);
      if (response?.data?.success) {
        return dispatch({ type: ADD_NEW_NARRATIVE_COMMENT, payload: { ...newCommentData, tags: newCommentData?.tag_ids, summaries: newCommentData?.summary_ids, ratings: newCommentData?.rating_ids, id: response?.data?.data?.id } || [] });
      }
      else toast.error(response?.data?.message);
    } catch (error) {
      throw error;
    }
  };
};

export const editNarrativeComment = (editCommentdata) => {
  return async (dispatch) => {
    try {
      const editedData = {
        ...editCommentdata,
        tag_ids: editCommentdata?.tag_ids?.filter((item) => item !== "")?.map((tag) => parseInt(tag?.id || tag)) || [],
        summary_ids: editCommentdata?.summary_ids?.filter((item) => item !== "")?.map((summaryTag) => parseInt(summaryTag?.id || summaryTag)) || [],
        rating_ids: editCommentdata?.rating_ids?.filter((item) => item !== "")?.map((rating) => parseInt(rating?.id || rating)) || [],
      };
      const response = await putApiCall(API_CONSTANTS.EDIT_COMMENT_BY_ID, editedData);
      if (response?.data?.success) return dispatch({ type: EDIT_NARRATIVE_COMMENT, payload: { ...editCommentdata, tags: editCommentdata?.tag_ids, summaries: editCommentdata?.summary_ids, ratings: editCommentdata?.rating_ids } || [] });
    } catch (error) {
      throw error;
    }
  };
};

export const updateDropDownValues = (data) => {
  return async (dispatch) => {
    const response = await putApiCall(API_CONSTANTS.EDIT_COMMENT_DROPDOWN_BY_ID, data);
    if (response?.data?.success) return dispatch({ type: UPDATE_DROPDOWN_VALUES, payload: data || [] });
    try {
    } catch (error) {
      throw error;
    }
  };
};

export const getCommentById = (id) => {
  return async (dispatch) => {
    try {
      const response = await getApiCall(`${API_CONSTANTS.GET_COMMENT_BY_ID}?comment_id=${id}`);
      if (response?.data?.success) return response.data.data;
      else return null;
    } catch (error) {
      throw error;
    }
  };
};

export const getCommentByIdNHT = (id) => {
  return async (dispatch) => {
    try {
      const response = await getApiCall(`${API_CONSTANTS.ADD_TO_LIBRARY_COMMENTS}/${id}`);
      if (response?.data?.success) return response.data.data;
      else return null;
    } catch (error) {
      throw error;
    }
  };
};

export const deleteCommentById = (id, formData = null) => {
  return async (dispatch) => {
    try {
      const response = await deleteApiCall(`${API_CONSTANTS.DELETE_COMMENT_BY_ID}?comment_id=${id}`);
      if (response?.data?.success) {
        dispatch({ type: DELETE_NARRATIVE_COMMENT, payload: id || [] });
        const nextPage = formData?.page ?? 1;
        const listResponse = await dispatch(getCommentLibraryList(nextPage, null, formData));
        return listResponse?.payload;
      } else return null;
    } catch (error) {
      throw error;
    }
  };
};

export const setEditorListner = (value) => {
  return { type: SET_EDITOR_LISTNER, payload: value };
};

export const duplicateComment = (row) => {
  return async (dispatch) => {
    try {
      const response = await postApiCall(`${API_CONSTANTS.ADD_DUPLICATE_COMMENT}?comment_id=${row?.id}`);
      if (response?.data?.success) {
        dispatch({ type: DUPLICATE_COMMENT, payload: { id: row?.id, response: response?.data?.data } || [] });
        return response?.data?.data;
      } else return null;
    } catch (error) {
      throw error;
    }
  };
}

export const addNonNarrativeComment = (data) => {
  return async (dispatch) => {
    try {
      const newAddData = {
        title: data?.prompt,
        comment: data?.recommendation,
        location: (data?.default_location || []).map(loc => loc.name).filter(Boolean).join(", "),
        tag_ids: (data?.tags || []).map((tag) => tag.id),
        rating_ids: (data?.ratings || []).map((rating) => parseInt(rating.Id)),
        ratings: data.ratings,
        comment_dropdowns: data.comment_dropdowns,
      };
      await postApiCall(API_CONSTANTS.ADD_TO_LIBRARY_COMMENTS, newAddData);
    } catch (error) {
      throw error;
    }
  };
}

export const getNNTagList = () => {
  return async (dispatch) => {
    try {
      const response = await getApiCall(API_CONSTANTS.FILTER_TAGS_LIST);
      return dispatch({ type: GET_NN_TAG_LIST, payload: response?.data?.data || [] });
    } catch (error) {
      throw error;
    }
  };
};

export const saveReorderSummary = (data) => {
  return async (dispatch) => {
    try {
      const response = await postApiCall(API_CONSTANTS.REORDER_SUMMARY, data)
      return dispatch({ type: GET_NN_TAG_LIST, payload: response?.data?.data || [] });
    } catch (error) {
      throw error;
    }
  }
}
